import Joi from 'joi';

export const validationOptions = {
  errors: {
    wrap: {
      label: '',
    },
  },
  abortEarly: false
};

const regValue = '^([^<]|a z|A Z|1 9|(.\\.))*$';
const textFieldWithLengthRegValue = '^([^<]|a z|A Z|1 9|(.\\.))*$';
const passwordRegValue = '(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\\W+)';

let validationFields = {
  email: Joi.string().email({ tlds: { allow: false } }).required().messages({
    'string.empty': 'This field cannot be blank',
    'string.email': 'Email must be a valid email',
  }),
  privacyPolicy: Joi.boolean().valid(true).required().messages({
    'string.empty': 'Please confirm that you have read the privacy policy.',
    'any.only': 'Please confirm that you have read the privacy policy.'
  }),
  termsOfUse: Joi.boolean().valid(true).required().messages({
    'string.empty': 'Please confirm that you have read the terms of use.',
    'any.only': 'Please confirm that you have read the terms of use.'
  }),
  textField: Joi.string().trim().pattern(new RegExp(regValue)).required().messages({
    'string.empty': 'This field cannot be blank',
  }),
  date: Joi.string().trim().pattern(new RegExp(regValue)).required().messages({
    'string.empty': 'This field cannot be blank',
  }),
  textFieldWithLength: Joi.string().trim().pattern(new RegExp(textFieldWithLengthRegValue))
    .max(30).required().messages({
      'string.empty': 'This field cannot be blank',
      'string.max': 'Must be 30 characters in length',
      'string.pattern.base': 'Text should not contain any HTML Tags'
    }),
  dropDown: Joi.string().required().messages({
    'string.empty': 'This field cannot be blank'
  }),
  password: Joi.string().min(8).pattern(new RegExp(passwordRegValue)).required().messages({
    'string.min': 'Password must be at least 8 characters long',
    'string.empty': 'This field cannot be blank',
    'string.pattern.base': 'Password must contain at least one digit, one lowercase letter, and one uppercase letter'
  }),
  confirmPassword: Joi.string().required().valid(Joi.ref('password')).messages({
    'any.only': 'Passwords do not match',
    'string.empty': 'This field cannot be blank'
  }),
};

export const schema = Joi.object({
  password: Joi.string()
    .min(16)
    .pattern(new RegExp(passwordRegValue))
    .required()
    .messages({ 
      'string.empty': 'Password cannot be blank',
      'string.only': 'Passwords do not match',
      'string.min': 'Password must be at least 16 characters long',
      'string.pattern.base': 'Password must contain at least one digit, one lowercase letter, one uppercase letter, and one special character'
    }),
  confirmPassword: Joi.any()
    .equal(Joi.ref('password'))
    .required()
    .messages({ 
      'any.only': 'Passwords do not match',
    }) // Custom error message
});

export const validateFields = Joi.object(validationFields).fork(Object.keys(validationFields), schema => schema.optional());